import { render, staticRenderFns } from "./productSelectionDetail.vue?vue&type=template&id=36a3fe86&scoped=true"
import script from "./productSelectionDetail.vue?vue&type=script&lang=js"
export * from "./productSelectionDetail.vue?vue&type=script&lang=js"
import style0 from "./productSelectionDetail.vue?vue&type=style&index=0&id=36a3fe86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3fe86",
  null
  
)

export default component.exports